import { BUY_PAGE_DEFAULT_LIMIT } from "@/libs/constants";
import { serverApi } from "@/libs/serverApi";

const { getPageData, getInitMakeData, getCarDetailsFilter } = serverApi();

export async function mapStrapiData(strapiData: any) {
  const imageFormat = (data: any) => {
    if (Array.isArray(data)) {
      data.map((item: any) => {
        const img = item.uploadImages.find(
          (i: any) => i?.primaryStatus == true
        );
        if (!img) {
          return;
        }
        const image_url = img.images;
        //replace the image url fit for source url
        if (img.images.includes("vehicle-listing")) {
          img.images =
            "/images/" +
            image_url.substring(
              image_url.indexOf("vehicle-listing"),
              image_url.length
            );
        } else if (!img.images.includes("jfif")) {
          img.images =
            "/images/" +
            image_url.substring(
              image_url.indexOf("listings"),
              image_url.length
            );
        }
      });
    }
  };

  const getMakeData = async () => {
    let data = await getInitMakeData();
    const makeArr = [];
    const resultData = {
      commonMakes: [],
      remainingMakes: [],
      ...(data?.results || {}),
    };
    for (let i = 0; i < resultData.commonMakes.length; i++) {
      makeArr.push(resultData.commonMakes[i]);
    }
    for (let i = 0; i < resultData.remainingMakes.length; i++) {
      makeArr.push(resultData.remainingMakes[i]);
    }
    return makeArr;
  };

  const setInitialVehicleType = (vehicleType: string) => {
    const type = vehicleType;
    if (type === "Car") {
      return "Auto";
    }
    return type || "All Vehicles";
  };

  const getMoreFilterData = async () => {
    let data = await getCarDetailsFilter();
    return data?.results;
  };

  const getData = async () => {
    const {
      VehicleType = "",
      Make = "",
      Model = [],
      YearMin = "",
      YearMax = "",
      BodyType = [],
      MilesMin = 0,
      MilesMax = 500000,
      Location = "",
      MinPrice = 0,
      MaxPrice = 1000000,
      Verification = "",
      Radius = "",
    } = strapiData?.Filters ?? {};
    console.log("\n\n", strapiData.Filters, "\n\n");

    const rows = strapiData.DisplayRows || 6;
    const limit =
      strapiData?.MaxListings && strapiData?.MaxListings > 0
        ? strapiData.MaxListings
        : BUY_PAGE_DEFAULT_LIMIT;
    const pageSize = limit;

    const morefilterInitial = {
      exteriorColor: [],
      interiorColor: [],
      fuelType: [],
      transmission: [],
      driveType: [],
      cylinders: [],
    };

    const response = await getPageData(
      rows,
      limit,
      0,
      VehicleType ? setInitialVehicleType(VehicleType) : VehicleType,
      "",
      Make,
      [Model],
      BodyType,
      MinPrice,
      MaxPrice,
      YearMin,
      YearMax,
      MilesMin,
      MilesMax,
      Verification,
      morefilterInitial,
      "", //location
      Location, //state
      0, //lat
      0, //lng
      Radius,
      "Newest"
    );

    const ttl = response._meta?.total || 0;

    imageFormat(response.data);
    imageFormat(response.similarListings);

    let current = 0;
    const pageData = response.data;
    const similarData = response.similarListings ?? null;
    return { pageData, similarData, total: ttl, current, pageSize };
  };
  const makeDataPromise = getMakeData();
  const moreFilterDataPromise = getMoreFilterData();
  const initalCarDataPromise = getData();

  const [makeData, moreFilterData, initialCarData] = await Promise.all([
    makeDataPromise,
    moreFilterDataPromise,
    initalCarDataPromise,
  ]);

  if (
    makeData.length === 0 ||
    moreFilterData.interiorColor.length === 0 ||
    initialCarData.total === 0
  ) {
    return null;
  }

  return { makeData, moreFilterData, initialCarData };
}
